import React, { useEffect, lazy, createElement } from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
declare global {
  interface Window {
    _wq: any[];
  }
}
export function TestimonialsSection() {
  useEffect(() => {
    // Initialize Wistia queue if not exists
    window._wq = window._wq || [];
    // Load Wistia player script
    const script = document.createElement('script');
    script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup if needed
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <section className="py-24 bg-slate-50 text-slate-900" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4" data-id="element-156">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-158">
            <p className="text-amber-600 font-bold tracking-wider uppercase mb-2" data-id="element-159">
              Testimonios
            </p>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-160">
              Lo que dicen quienes ya{' '}
              <span className="text-amber-600" data-id="element-161">jugaron desde otro nivel</span>
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-162">
              Resultados reales de líderes y vendedores que transformaron su
              forma de trabajar
            </p>
          </motion.div>
        </div>

        {/* Testimonials Grid - 5 items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-163">
          {/* Video Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-200 hover:shadow-xl transition-shadow" data-id="element-164">
            <div className="relative aspect-[9/16] bg-slate-100" data-id="element-165">
              <div className="wistia_responsive_padding" style={{
              padding: '193.61% 0 0 0',
              position: 'relative'
            }} data-id="element-166">
                <div className="wistia_responsive_wrapper" style={{
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%'
              }} data-id="element-167">
                  <div className="wistia_embed wistia_async_zadn492ltd seo=true videoFoam=true" style={{
                  height: '100%',
                  position: 'relative',
                  width: '100%'
                }} data-id="element-168">
                    <div className="wistia_swatch" style={{
                    height: '100%',
                    left: 0,
                    opacity: 0,
                    overflow: 'hidden',
                    position: 'absolute',
                    top: 0,
                    transition: 'opacity 200ms',
                    width: '100%'
                  }} data-id="element-169">
                      <img src="https://fast.wistia.com/embed/medias/zadn492ltd/swatch" style={{
                      filter: 'blur(5px)',
                      height: '100%',
                      objectFit: 'contain',
                      width: '100%'
                    }} alt="Video testimonial" aria-hidden="true" data-id="element-170" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Video Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-200 hover:shadow-xl transition-shadow" data-id="element-171">
            <div className="relative aspect-[9/16] bg-slate-100" data-id="element-172">
              <div className="wistia_responsive_padding" style={{
              padding: '216.67% 0 0 0',
              position: 'relative'
            }} data-id="element-173">
                <div className="wistia_responsive_wrapper" style={{
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%'
              }} data-id="element-174">
                  <div className="wistia_embed wistia_async_yvvx8j89ec seo=true videoFoam=true" style={{
                  height: '100%',
                  position: 'relative',
                  width: '100%'
                }} data-id="element-175">
                    <div className="wistia_swatch" style={{
                    height: '100%',
                    left: 0,
                    opacity: 0,
                    overflow: 'hidden',
                    position: 'absolute',
                    top: 0,
                    transition: 'opacity 200ms',
                    width: '100%'
                  }} data-id="element-176">
                      <img src="https://fast.wistia.com/embed/medias/yvvx8j89ec/swatch" style={{
                      filter: 'blur(5px)',
                      height: '100%',
                      objectFit: 'contain',
                      width: '100%'
                    }} alt="Video testimonial" aria-hidden="true" data-id="element-177" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Video Testimonial 3 - NUEVO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-200 hover:shadow-xl transition-shadow" data-id="element-178">
            <div className="relative aspect-[9/16] bg-slate-100" data-id="element-179">
              <div className="wistia_responsive_padding" style={{
              padding: '216.22% 0 0 0',
              position: 'relative'
            }} data-id="element-180">
                <div className="wistia_responsive_wrapper" style={{
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%'
              }} data-id="element-181">
                  <div className="wistia_embed wistia_async_rkj8snygct seo=true videoFoam=true" style={{
                  height: '100%',
                  position: 'relative',
                  width: '100%'
                }} data-id="element-182">
                    <div className="wistia_swatch" style={{
                    height: '100%',
                    left: 0,
                    opacity: 0,
                    overflow: 'hidden',
                    position: 'absolute',
                    top: 0,
                    transition: 'opacity 200ms',
                    width: '100%'
                  }} data-id="element-183">
                      <img src="https://fast.wistia.com/embed/medias/rkj8snygct/swatch" style={{
                      filter: 'blur(5px)',
                      height: '100%',
                      objectFit: 'contain',
                      width: '100%'
                    }} alt="Video testimonial" aria-hidden="true" data-id="element-184" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-200 hover:shadow-xl transition-shadow" data-id="element-185">
            <div className="relative aspect-[9/16]" data-id="element-186">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768078360/Story_Carolina_Go%CC%81mez_yvure8.jpg" alt="Testimonio de cliente satisfecho" className="w-full h-full object-cover" loading="lazy" data-id="element-187" />
              <div className="absolute top-4 left-4" data-id="element-188">
                <Quote className="w-8 h-8 text-amber-500 opacity-80" data-id="element-189" />
              </div>
            </div>
          </motion.div>

          {/* Image Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-200 hover:shadow-xl transition-shadow" data-id="element-190">
            <div className="relative aspect-[9/16]" data-id="element-191">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768078360/IMG_5632_jojln3.png" alt="Testimonio de cliente satisfecho" className="w-full h-full object-cover" loading="lazy" data-id="element-192" />
              <div className="absolute top-4 left-4" data-id="element-193">
                <Quote className="w-8 h-8 text-amber-500 opacity-80" data-id="element-194" />
              </div>
            </div>
          </motion.div>
        </div>

        {/* Trust Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="mt-12 text-center" data-id="element-195">
          <p className="text-slate-600 text-lg" data-id="element-196">
            <span className="font-bold text-amber-600" data-id="element-197">
              Miles de profesionales
            </span>{' '}
            han transformado su forma de liderar y vender
          </p>
        </motion.div>
      </div>
    </section>;
}